import isEmpty from 'lodash/isEmpty';

import { getWindowObject } from '@eb/feature-detection';

function _gaPrefixFromTrackerName(trackerName) {
    return isEmpty(trackerName) ? '' : `${trackerName}.`;
}
/**
 * Set attribute on a Google Analytics tracker through the API
 * attributes are one of many potential items the tracker
 * maintains on its self. Setting ensures that the assigned
 * attribute holds that value throughout the trackers
 * lifetime. Valuable for SPAs which need to update location
 * or page values on route changes.
 *
 * @param  {object} gaPropertiesToSet
 * @param  {string} trackerName The optional tracker name
 */
export function setAttributes(gaPropertiesToSet, trackerName) {
    const ga = getWindowObject('ga');

    if (ga) {
        const prefix = _gaPrefixFromTrackerName(trackerName);

        ga(`${prefix}set`, gaPropertiesToSet);
    }
}
